/**
 * Portal Manta · Dados
 * Extraído de portal_manta_v28_12.jsx
 * v29 modular · 2026-05-11
 */

export const SHAREPOINT_FAVS = [
  {
    id: 'antt-pr-projetos',
    nome: 'ANTT-PR · Projetos (lote-X.json)',
    path: '/personal/mneves_mantaassociados_com/Documents/Documentos - Copia/Claude/Projects/ORÇAMENTAÇÃO - MANTA/projetos/',
    url: 'https://mnassociados-my.sharepoint.com/personal/mneves_mantaassociados_com/Documents/Documentos%20-%20Copia/Claude/Projects/ORÇAMENTAÇÃO%20-%20MANTA/projetos/',
    arquivos: ['lote-1.json', 'lote-2.json', 'lote-3.json', 'lote-4.json', 'lote-5.json', 'lote-6.json'],
    descricao: 'JSONs estruturados PER+MEF dos lotes paranaenses',
  },
  {
    id: 'antt-pr-data',
    nome: 'ANTT-PR · data_v5 (consolidados)',
    path: '/personal/mneves_mantaassociados_com/Documents/Documentos - Copia/Cowork/Projects/Orcamento Parana/data_v5/',
    url: 'https://mnassociados-my.sharepoint.com/personal/mneves_mantaassociados_com/Documents/Documentos%20-%20Copia/Cowork/Projects/Orcamento%20Parana/data_v5/',
    arquivos: ['lotes_info.json', 'orcamento_antt_lotes.json'],
    descricao: 'Dados consolidados ANTT (todos lotes, capex MEF)',
  },
  {
    id: 'l4-egtc',
    nome: 'EGTC · Linha 4 (Metrô SP)',
    path: '/sites/Engenharia/02_CLIENTE/06_EGTC/13_GESTÃO DE EQUIPAMENTOS/CLAUDE/JSON/',
    url: 'https://mnassociados.sharepoint.com/sites/Engenharia/02_CLIENTE/06_EGTC/13_GESTÃO%20DE%20EQUIPAMENTOS/CLAUDE/JSON/',
    arquivos: ['LINHA19_LOTE2.json', 'LINHA19_LOTE3.json'],
    descricao: 'Cronogramas EGTC · Linha 19 do Metrô SP',
  },
  {
    id: 'l4-relatorios',
    nome: 'L4 · Relatórios técnicos (07-relatorios)',
    path: '/ANTT_PR/07-relatorios/',
    url: '',
    arquivos: [],
    descricao: 'Pasta master para relatórios consolidados (placeholder · ajuste com URL real)',
    placeholder: true,
  },
];
